import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/sections/Hero";
import About from "@/sections/About";
import Domaines from "@/sections/Domaines";
import Services from "@/sections/Services";
import Manifesto from "@/sections/Manifesto";
import Marquee from "@/sections/Marquee";
import WhyUs from "@/sections/WhyUs";
import BeforeAfterSection from "@/sections/BeforeAfterSection";
import Zone from "@/sections/Zone";
import Reviews from "@/sections/Reviews";
import Excellence from "@/sections/Excellence";
import FinalCTA from "@/sections/FinalCTA";
import Contact from "@/sections/Contact";
import Seo from "@/components/Seo";
import { SITE, LOGO, IMG, SERVICES } from "@/data/content";
import { scrollToId } from "@/components/SmoothScroll";

const businessLd = {
    "@context": "https://schema.org",
    "@type": ["CleaningService", "LocalBusiness"],
    "@id": SITE.url + "/#business",
    name: SITE.name,
    image: SITE.url + LOGO,
    logo: SITE.url + LOGO,
    url: SITE.url + "/",
    telephone: SITE.phoneIntl,
    email: SITE.email,
    priceRange: SITE.priceRange,
    address: {
        "@type": "PostalAddress",
        streetAddress: "32 allée de la Robertsau",
        postalCode: "67000",
        addressLocality: "Strasbourg",
        addressRegion: "Grand Est",
        addressCountry: "FR",
    },
    geo: { "@type": "GeoCoordinates", latitude: SITE.geo.lat, longitude: SITE.geo.lng },
    areaServed: SITE.areaServed.map((a) => ({ "@type": "Place", name: a })),
    openingHoursSpecification: [
        {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
            opens: "07:00",
            closes: "21:00",
        },
    ],
    sameAs: SITE.sameAs,
    aggregateRating: { "@type": "AggregateRating", ratingValue: SITE.rating, reviewCount: SITE.reviewCount },
    makesOffer: SERVICES.cards.map((c) => ({ "@type": "Offer", itemOffered: { "@type": "Service", name: c.title } })),
};

const websiteLd = { "@context": "https://schema.org", "@type": "WebSite", name: SITE.name, url: SITE.url + "/" };

export default function Home() {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace("#", "");
            setTimeout(() => scrollToId(id), 400);
        }
    }, [location]);

    return (
        <main>
            <Seo
                title="IGN Services Alsace | Nettoyage professionnel à Strasbourg et en Alsace"
                description="Entreprise de nettoyage professionnel à Strasbourg et en Alsace : entretien de bureaux, désinfection, vitrerie, remise en état, fin de chantier. Devis gratuit sous 24h, intervention 7j/7."
                canonical={SITE.url}
                image={IMG.hero}
                jsonLd={[businessLd, websiteLd]}
            />
            <Hero />
            <About />
            <Domaines />
            <Services />
            <Manifesto />
            <Marquee />
            <WhyUs />
            <BeforeAfterSection />
            <Zone />
            <Reviews />
            <Excellence />
            <FinalCTA />
            <Contact />
        </main>
    );
}
